import { Trans } from "react-i18next";
import { Link } from "react-router-dom";
import * as PATH from "../../utils/Contants"; //"../../global/Contants";
import style from "./Footer.module.css";
export default function Footer() {
  return (
    <>
      <div className={style.footer}>
        <div className={style.innerFooter}>
          <ul>
            {process.env.REACT_APP_BACKEND ==
              "https://suepsso.octopus-tech.com" ||
              window.location.host.includes("hkpl") ||
              process.env.REACT_APP_CLIENT_ID === "hkpl" ? (
              <></>
            ) : (
              <>
                {" "}
                <li>
                  <Link to={PATH.APPDOWNLOAD}>
                    <Trans>app</Trans>
                  </Link>
                </li>
                <li>&nbsp;|&nbsp;</li>
              </>
            )}

            <li>
              <Link to={PATH.ABOUTS}>
                <Trans>Aboutus</Trans>
              </Link>
            </li>
            <li>&nbsp;|&nbsp;</li>
            {/*
            {process.env.REACT_APP_BACKEND ==
              "https://suepsso.octopus-tech.com" ||
              window.location.host.includes("hkpl") ||
              process.env.REACT_APP_CLIENT_ID === "hkpl" ? (
              <></>
            ) : (
              <>
                {" "}
                <li>
                  <Link to={PATH.MEDIA}>
                    <Trans>SocialMedia</Trans>
                  </Link>
                </li>
                <li>&nbsp;|&nbsp;</li>
              </>
            )}
            */}
            {process.env.REACT_APP_BACKEND ==
              "https://suepsso.octopus-tech.com" ||
              window.location.host.includes("hkpl") ||
              process.env.REACT_APP_CLIENT_ID === "hkpl" ? (
              <></>
            ) : (
              <>
                {" "}
                <li>
                  <Link to={PATH.FBCLUB}>
                    <Trans>ReadingClub</Trans>
                  </Link>
                </li>
                <li>&nbsp;|&nbsp;</li>
              </>
            )}

            {process.env.REACT_APP_BACKEND ==
              "https://suepsso.octopus-tech.com" ||
              window.location.host.includes("hkpl") ||
              process.env.REACT_APP_CLIENT_ID === "hkpl" ? (
              <></>
            ) : (
              <>
                {" "}
                <li>
                  <Link to={PATH.MANUAL}>
                    <Trans>manual</Trans>
                  </Link>
                </li>
                <li>&nbsp;|&nbsp;</li>
              </>
            )}

            <li>
              <Link to={PATH.POLICY}>
                <Trans>policy</Trans>
              </Link>
            </li>
          </ul>
          <div style={{ marginTop: "8px" }}>
            <span style={{
              margin: "0",
              padding: "0",
              border: "0",
              fontSize: "100%",
              font: "inherit",
              verticalAlign: "baseline",
            }}>
              Copyright @2023 SUEP | Powered by Octopus InfoTech Limited.
            </span>
          </div>
        </div>
      </div>
    </>
  );
}
